export default __webpack_public_path__ + "static/media/3-Infantil.e07ec9b7.png";